<template>
  <div class="cf-card cf-flex cf-flex--row cf-flex--align-center cf-flex--justify-space-between cf-flex--gap-16 cf-mobile-column">
    <div class="cf-flex cf-flex--column cf-flex--align-start cf-flex--gap-8">
      <h3 class="cf-title cf-title--3">
        {{ scanToEarnContent }}
      </h3>
    </div>

    <button
      class="cf-button cf-button--primary cf-button--md cf-button--mobile-fill cf-align-self-center"
      type="button"
      @click="$openModal('loyaltyScanModal')"
    >
      <span class="cf-icon cf-icon--white far fa-qrcode" />
      Scan
    </button>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';


  export default {
    name: 'ScanToEarnCta',

    computed: {
      ...mapGetters('content', ['content']),
      ...mapGetters('merchant', ['merchant']),

      scanToEarnContent() {
        const isLoyaltyCheckInEnabled = this.merchant.options.loyaltyOptions.loyaltyCheckInEnabled;

        const isLoyaltyReceiptScanningEnabled = this.merchant.options.loyaltyOptions.loyaltyReceiptScanningEnabled;

        if (isLoyaltyCheckInEnabled && isLoyaltyReceiptScanningEnabled) {
          return this.content.ScanToCheckInAndEarnLoyaltyScreen.metadata.scanToEarnCta;
        }

        if (isLoyaltyReceiptScanningEnabled) {
          return this.content.ScanToEarnLoyaltyScreen.metadata.scanToEarnCta;
        }

        if (isLoyaltyCheckInEnabled) {
          return this.content.ScanToCheckInLoyaltyScreen.metadata.scanToCheckInCta;
        }

        return '';
      }
    }
  };
</script>

